class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    if (!this.notification) return;

    this.notification.addEventListener('keyup', (evt) => {
      if (evt.code === 'Escape') this.close();
    });

    this.querySelectorAll('[data-cart-notification-close]').forEach((button) => {
      button.addEventListener('click', this.close.bind(this));
    });

    const bulbUpsellButton = this.querySelector('[data-slg-bulb-upsell-add]');
    if (bulbUpsellButton) {
      bulbUpsellButton.addEventListener('click', this.addBulbUpsell.bind(this));
    } 

    const bulbChoices = this.querySelector('[data-slg-bulb-upsell-choices]');
    if (bulbChoices) {
      bulbChoices.addEventListener('change', (event) => {
        const radio = event.target.closest('[data-slg-upsell-bulb-radio]');
        if (!radio) return;

        const button = this.querySelector('[data-slg-bulb-upsell-add]');
        const variantId = Number(radio.dataset.variantId || radio.value);

        if (button && variantId) {
          button.dataset.variantId = String(variantId);
        }
      });
    }
  }

  open() {
    if (!this.notification) return;

    this.classList.add('is-open');
    this.notification.classList.add('animate', 'active');

    window.setTimeout(() => {
      try {
        this.notification.focus({ preventScroll: true });
      } catch (e) {
        this.notification.focus();
      }

      if (typeof trapFocus === 'function') {
        trapFocus(this.notification);
      }
    }, 80);

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    if (!this.notification) return;

    this.classList.remove('is-open');
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(this.activeElement);
    }
  }

  renderContents(parsedState) {
  const addedItems = this.getAddedItems(parsedState);

  this.renderCartIcon(parsedState);
  this.renderAddedProduct(addedItems);
  this.renderFreeShippingProgress();
  this.updateBulbUpsell(addedItems);
  this.renderProductUpsells(addedItems);

  if (this.header && typeof this.header.reveal === 'function') {
    this.header.reveal();
  }

  this.open();
}

  getSectionsToRender() {
    return [
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  renderCartIcon(parsedState) {
    if (!parsedState || !parsedState.sections) return;

    const sectionHtml = parsedState.sections['cart-icon-bubble'];
    const target = document.getElementById('cart-icon-bubble');

    if (!sectionHtml || !target) return;

    const html = this.getSectionInnerHTML(sectionHtml);
    if (html !== null) {
      target.innerHTML = html;
    }
  }

  getAddedItems(parsedState) {
    if (!parsedState) return [];
    if (Array.isArray(parsedState.items)) return parsedState.items;
    return [parsedState];
  }

  getMainItem(items) {
    return (
      items.find((item) => {
        return !(item.properties && item.properties._addon === 'bulb');
      }) || items[0]
    );
  }

  getBulbItem(items) {
    const bulbVariantId = this.getBulbVariantId();

    return items.find((item) => {
      const itemId = Number(item.id || item.variant_id);
      return (
        itemId === bulbVariantId ||
        (item.properties && item.properties._addon === 'bulb')
      );
    });
  }

  getVariantIdFromElement(el) {
    if (!el) return 0;

    const candidates = [
      el.dataset.addonVariant,
      el.dataset.addonVariantId,
      el.dataset.bulbVariant,
      el.dataset.bulbVariantId,
      el.dataset.variant,
      el.dataset.variantId,
      el.dataset.id,
      el.value,
    ];

    for (const candidate of candidates) {
      const id = Number(candidate);
      if (Number.isFinite(id) && id > 0) return id;
    }

    return 0;
  }

  getBulbVariantId() {
    const context = window.__SLG_LAST_ADD_CONTEXT || {};
    const fromContext = Number(context.bulbVariantId);

    if (fromContext) return fromContext;

    const checkbox = document.getElementById('addon-bulb');

    const box =
      document.querySelector('.addon-bulb-box') ||
      document.querySelector('[data-addon-bulb]') ||
      document;

    const checkedColor =
      box.querySelector('input[type="radio"]:checked') ||
      box.querySelector('[data-addon-variant]:checked') ||
      box.querySelector('[data-addon-variant-id]:checked') ||
      box.querySelector('[data-bulb-variant]:checked') ||
      box.querySelector('[data-bulb-variant-id]:checked');

    let id = this.getVariantIdFromElement(checkedColor);
    if (id) return id;

    id = this.getVariantIdFromElement(checkbox);
    if (id) return id;

    const fallbackEl =
      box.querySelector('[data-addon-variant]') ||
      box.querySelector('[data-addon-variant-id]') ||
      box.querySelector('[data-bulb-variant]') ||
      box.querySelector('[data-bulb-variant-id]') ||
      box.querySelector('[data-variant-id]') ||
      box.querySelector('input[name="bulb_variant_id"]') ||
      box.querySelector('input[name="addon_variant_id"]');

    return this.getVariantIdFromElement(fallbackEl);
  }

  hasBulbInAddedItems(items) {
    const context = window.__SLG_LAST_ADD_CONTEXT || {};
    const bulbVariantId = this.getBulbVariantId();

    if (Boolean(context.wantsBulb)) return true;

    return items.some((item) => {
      const itemId = Number(item.id || item.variant_id);
      return (
        itemId === bulbVariantId ||
        (item.properties && item.properties._addon === 'bulb')
      );
    });
  }

  getBulbChoiceOptions() {
    const box =
      document.querySelector('.addon-bulb-box') ||
      document.querySelector('[data-addon-bulb]');

    if (!box) return [];

    const radios = Array.from(box.querySelectorAll('input[type="radio"]'));

    return radios
      .map((radio, index) => {
        const variantId = this.getVariantIdFromElement(radio);
        if (!variantId) return null;

        const labelEl =
          box.querySelector(`label[for="${radio.id}"]`) ||
          radio.closest('label');

        const label =
          radio.dataset.label ||
          (labelEl ? labelEl.textContent.trim() : '') ||
          radio.value ||
          `Lichtfarbe ${index + 1}`;

        return {
          variantId,
          label,
          checked: radio.checked || index === 0,
        };
      })
      .filter(Boolean);
  }

  renderBulbChoices(defaultVariantId) {
    const choicesWrap = this.querySelector('[data-slg-bulb-upsell-choices]');
    const button = this.querySelector('[data-slg-bulb-upsell-add]');
    if (!choicesWrap || !button) return;

    const choices = this.getBulbChoiceOptions();

    if (!choices.length) {
      choicesWrap.hidden = true;
      button.dataset.variantId = String(defaultVariantId || this.getBulbVariantId());
      return;
    }

    choicesWrap.hidden = false;

    choicesWrap.innerHTML = `
      <p class="slg-cart-upsell-card__choice-label">Lichtfarbe wählen:</p>
      <div class="slg-cart-upsell-card__choice-list">
        ${choices
          .map((choice, index) => {
            const checked = choice.checked ? 'checked' : '';
            return `
              <label class="slg-cart-upsell-card__choice">
                <input
                  type="radio"
                  name="slg-upsell-bulb-choice"
                  value="${choice.variantId}"
                  data-variant-id="${choice.variantId}"
                  data-slg-upsell-bulb-radio
                  ${checked}
                >
                <span>${this.escapeHtml(choice.label)}</span>
              </label>
            `;
          })
          .join('')}
      </div>
    `;

    const checkedRadio = choicesWrap.querySelector('[data-slg-upsell-bulb-radio]:checked');
    const selectedVariantId = Number(checkedRadio && checkedRadio.dataset.variantId);

    if (selectedVariantId) {
      button.dataset.variantId = String(selectedVariantId);
    }
  }

  renderAddedProduct(items) {
    const target = document.getElementById('cart-notification-product');
    if (!target) return;

    const mainItem = this.getMainItem(items);
    if (!mainItem) {
      target.innerHTML = '';
      return;
    }

    const image =
      mainItem.featured_image && mainItem.featured_image.url
        ? mainItem.featured_image.url
        : mainItem.image || '';

    const title = mainItem.product_title || mainItem.title || 'Artikel';
    const variant =
      mainItem.variant_title && mainItem.variant_title !== 'Default Title'
        ? mainItem.variant_title
        : '';

    const quantity = Number(mainItem.quantity) || 1;

const preorder =
  mainItem.properties &&
  mainItem.properties.Vorbestellung
    ? String(mainItem.properties.Vorbestellung)
    : '';

target.innerHTML = `
      <div class="slg-cart-notification-item">
        ${
          image
            ? `<div class="slg-cart-notification-item__media">
                <img src="${this.escapeHtml(image)}" alt="${this.escapeHtml(title)}" loading="lazy">
              </div>`
            : ''
        }

        <div class="slg-cart-notification-item__content">
          <p class="slg-cart-notification-item__title">${this.escapeHtml(title)}</p>
          ${variant ? `<p class="slg-cart-notification-item__variant">Größe: ${this.escapeHtml(variant)}</p>` : ''}

${
  preorder
    ? `<p class="slg-cart-notification-item__preorder">
        Vorbestellung · ${this.escapeHtml(preorder)}
      </p>`
    : ''
}

<p class="slg-cart-notification-item__qty">Menge: ${quantity}</p>
        </div>
      </div>
    `;
  }

  async renderFreeShippingProgress() {
  const wrapper = this.querySelector('[data-slg-free-shipping]');
  const text = this.querySelector('[data-slg-free-shipping-text]');
  const fill = this.querySelector('[data-slg-free-shipping-fill]');
  const bar = this.querySelector('[data-slg-free-shipping-bar]');

  if (!wrapper || !text || !fill || !bar) return;

  const threshold = Number(wrapper.dataset.threshold) || 9000;

  wrapper.hidden = true;

  try {
    const response = await fetch('/cart.js', {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
      credentials: 'same-origin',
      cache: 'no-store',
    });

    if (!response.ok) {
      throw new Error('Warenkorb konnte nicht geladen werden.');
    }

    const cart = await response.json();

    const total = Number(cart.total_price) || 0;
    const remaining = Math.max(threshold - total, 0);

    const progress =
      threshold > 0
        ? Math.min(100, Math.max(0, (total / threshold) * 100))
        : 100;

    const reached = remaining === 0;

    wrapper.classList.toggle('is-reached', reached);

    fill.style.width = `${progress}%`;

    bar.setAttribute(
      'aria-valuenow',
      String(Math.round(progress))
    );

    if (reached) {
      text.textContent = '✓ Kostenloser Versand erreicht';
    } else {
      text.textContent =
        `Noch ${this.formatMoneyFromRecommendation(remaining)} bis zum kostenlosen Versand`;
    }

    wrapper.hidden = false;
  } catch (error) {
    console.error(
      '[cart-notification] Versandfortschritt konnte nicht geladen werden:',
      error
    );

    wrapper.hidden = true;
  }
}

  updateBulbUpsell(items) {
    const upsell = this.querySelector('[data-slg-bulb-upsell]');
    const button = this.querySelector('[data-slg-bulb-upsell-add]');
    const success = this.querySelector('[data-slg-bulb-upsell-success]');

    if (!upsell || !button) return;

    const bulbVariantId = this.getBulbVariantId();
    const hasBulb = this.hasBulbInAddedItems(items);

    if (!bulbVariantId || hasBulb) {
      upsell.hidden = true;
      return;
    }

    const context = window.__SLG_LAST_ADD_CONTEXT || {};
    const mainItem = this.getMainItem(items);

    const qty =
      Number(context.quantity) ||
      Number(mainItem && mainItem.quantity) ||
      1;

    button.dataset.variantId = String(bulbVariantId);
    button.dataset.quantity = String(qty);

    button.classList.remove('is-added');
    button.classList.remove('is-loading');
    button.disabled = false;
    button.textContent = 'Glühbirne hinzufügen +2,90 €';

    if (success) success.hidden = true;

    this.renderBulbChoices(bulbVariantId);

    upsell.hidden = false;
  }

  async renderProductUpsells(items) {
    const section = this.querySelector('[data-slg-product-upsell]');
    const grid = this.querySelector('[data-slg-product-upsell-grid]');

    if (!section || !grid) return;

    const mainItem = this.getMainItem(items);
    const productId = Number(mainItem && mainItem.product_id);

    if (!productId) {
      section.hidden = true;
      return;
    }

    section.hidden = false;
    grid.innerHTML = '<p class="slg-cart-product-upsell__loading">Empfehlungen werden geladen …</p>';

    try {
      const response = await fetch(`/recommendations/products.json?product_id=${productId}&limit=4&intent=related`, {
        headers: {
          Accept: 'application/json',
        },
      });

      const data = await response.json();
      const products = Array.isArray(data.products) ? data.products : [];

      const filteredProducts = products.filter((product) => {
        return Number(product.id) !== productId;
      });

      if (!filteredProducts.length) {
        section.hidden = true;
        return;
      }

      grid.innerHTML = filteredProducts
        .slice(0, 4)
        .map((product) => this.renderProductUpsellCard(product))
        .join('');
    } catch (error) {
      console.error('[cart-notification] Produktempfehlungen konnten nicht geladen werden:', error);
      section.hidden = true;
    }
  }

  renderProductUpsellCard(product) {
    const title = product.title || 'Produkt';
    const url = product.url || `/products/${product.handle}`;
    const image =
      product.featured_image ||
      (product.images && product.images[0]) ||
      '';

    const price = this.formatMoneyFromRecommendation(product.price);

    return `
      <a class="slg-cart-product-upsell-card" href="${this.escapeHtml(url)}">
        <div class="slg-cart-product-upsell-card__media">
          ${
            image
              ? `<img src="${this.escapeHtml(image)}" alt="${this.escapeHtml(title)}" loading="lazy">`
              : ''
          }
        </div>

        <div class="slg-cart-product-upsell-card__content">
          <p class="slg-cart-product-upsell-card__title">${this.escapeHtml(title)}</p>
          ${price ? `<p class="slg-cart-product-upsell-card__price">${this.escapeHtml(price)}</p>` : ''}
        </div>
      </a>
    `;
  }

  formatMoneyFromRecommendation(price) {
    const amount = Number(price);
    if (!Number.isFinite(amount)) return '';

    try {
      return new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
      }).format(amount / 100);
    } catch (e) {
      return (amount / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  async addBulbUpsell(event) {
    const button = event.currentTarget;
    const selectedRadio = this.querySelector('[data-slg-upsell-bulb-radio]:checked');

    const variantId = Number(
      (selectedRadio && selectedRadio.dataset.variantId) ||
      button.dataset.variantId
    );

    const quantity = Number(button.dataset.quantity) || 1;

    if (!variantId) return;

    button.classList.add('is-loading');
    button.disabled = true;
    button.textContent = 'Wird hinzugefügt …';

    try {
      const sections = this.getSectionsToRender()
        .map((section) => section.id)
        .join(',');

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          id: variantId,
          quantity: quantity,
          properties: {
            _addon: 'bulb',
          },
          sections: sections,
          sections_url: window.location.pathname,
        }),
      });

      const parsedState = await response.json();

      if (!response.ok || parsedState.status) {
        throw new Error(parsedState.description || 'Glühbirne konnte nicht hinzugefügt werden.');
      }

      this.renderCartIcon(parsedState);

      const upsell = this.querySelector('[data-slg-bulb-upsell]');
if (upsell) upsell.hidden = true;

await this.renderFreeShippingProgress();

document.dispatchEvent(new CustomEvent('cart:updated'));
    } catch (error) {
      console.error('[cart-notification] Fehler beim Glühbirnen-Upsell:', error);

      button.classList.remove('is-loading');
      button.disabled = false;
      button.textContent = 'Glühbirne hinzufügen +2,90 €';
    }
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const parsed = new DOMParser().parseFromString(html, 'text/html');

    if (selector) {
      const selected = parsed.querySelector(selector);
      if (selected) return selected.innerHTML;
    }

    const body = parsed.body;
    if (body && body.innerHTML) return body.innerHTML;

    return null;
  }

  handleBodyClick(evt) {
    const target = evt.target;

    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }
}

if (!customElements.get('cart-notification')) {
  customElements.define('cart-notification', CartNotification);
}